import { Component, Inject } from "@angular/core";
import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faXmark } from "@fortawesome/pro-light-svg-icons";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { InfoModalBullet, InfoModalData } from "./info-modal.model";

@Component({
  selector: "app-info-modal",
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: "./info-modal.component.html"
})
export class InfoModalComponent {
  protected readonly faXmark: IconDefinition = faXmark;

  constructor(
    public dialogRef: DialogRef<void>,
    @Inject(DIALOG_DATA) public data: InfoModalData
  ) {}

  protected isIconBullet(bullet: string | InfoModalBullet): bullet is InfoModalBullet {
    return typeof bullet === "object" && "icon" in bullet;
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
